import PESService from 'App/services/PESService';
import { useQuery } from 'react-query';

function useFetchWorkQueueResult(filters) {
    return useQuery(['work_queue', JSON.stringify(filters)], () => PESService.getWorkqueue(filters), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchWorkQueueResult;
